// extracted by mini-css-extract-plugin
module.exports = {"heart":"shared-components-FavoriteButton-FavoriteButton__heart--3ntDx"};